export default __webpack_public_path__ + "static/media/Arrow.c720ddb1.svg";